import React, { useState, useLayoutEffect } from "react";
import { Box, theme, IconButton } from "@aksara-ui/react";
import { IconDragHorizontal } from "@aksara-ui/icons";
import { ReactComponent as LogoText } from "assets/images/kata-dashboard.svg";
import { ReactComponent as Logo } from "assets/images/logo.svg";
import Menus from "./components/Menus";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { setDrawerDesktop, setDrawerMobile } from "redux/actions";
import { NavLink } from "react-router-dom";

const Sidebar: React.FC = () => {
  const dispatch = useDispatch();
  const { isDrawerDesktopOpen, isDrawerMobileOpen } = useSelector(
    (state: any) => state.globalReducer
  );
  const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });

  const closeDrawerMobile = () => {
    dispatch(setDrawerMobile(false));
  };

  const handleDrawerDesktop = () => {
    dispatch(setDrawerDesktop(!isDrawerDesktopOpen));
  };

  const useWindowSize = () => {
    const [size, setSize] = useState(0);
    useLayoutEffect(() => {
      function updateSize() {
        setSize(window.innerWidth);
        if (window.innerWidth <= 1007) {
          dispatch(setDrawerDesktop(false));
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  };

  useWindowSize();

  return (
    <>
      {!isTabletOrMobile ? (
        <Box
          width={isDrawerDesktopOpen ? 280 : 100}
          height={"100vh"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"left"}
          background={theme.colors.white}
          borderRight={`1px solid ${theme.colors.grey03}`}
          position={"fixed"}
          zIndex={20}
          style={{
            minWidth: isDrawerDesktopOpen ? 280 : 100,
            transition: "width 0.3s ease-in-out",
          }}
        >
          <IconButton
            onClick={() => handleDrawerDesktop()}
            style={{
              position: "absolute",
              right: -15,
              top: 12,
              borderRadius: "50%",
              backgroundColor: `${theme.colors.grey02}`,
              borderColor: `${theme.colors.grey04}`,
            }}
            type={"button"}
          >
            <IconDragHorizontal fill={"currentColor"} />
          </IconButton>

          <Box
            paddingY={10}
            paddingX={25}
            display={"flex"}
            justifyContent={"center"}
          >
            <NavLink to="/">
              {isDrawerDesktopOpen ? (
                <LogoText width={"100%"} />
              ) : (
                <Logo width={25} />
              )}
            </NavLink>
          </Box>
          <Box p={"5px 12px"} overflow={"auto"} paddingBottom={20}>
            <Menus sidebarExpand={isDrawerDesktopOpen} />
          </Box>
        </Box>
      ) : (
        <Drawer
          open={isDrawerMobileOpen}
          onClose={closeDrawerMobile}
          direction={"left"}
        >
          <Box
            height={"100vh"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"left"}
            background={theme.colors.white}
            borderRight={`1px solid ${theme.colors.grey03}`}
            position={"relative"}
            style={{ transition: "all 0.25s" }}
          >
            <Box
              paddingY={10}
              paddingX={25}
              display={"flex"}
              justifyContent={"center"}
            >
              <NavLink to="/">
                <LogoText width={"100%"} />
              </NavLink>
            </Box>

            <Box p={"5px 12px"} overflow={"auto"} paddingBottom={20}>
              <Menus sidebarExpand={true} />
            </Box>
          </Box>
        </Drawer>
      )}
    </>
  );
};

export default Sidebar;
